import { CariSTTRepositoryInterface } from "@/data/persistences/repositories/contracts/CariSTTRepositoryInterface";
import { CariSTTMapper } from "@/data/persistences/mappers/CariSTTMapper";
import {
  CariSttEntities,
  CariSttRequest,
  DetailSttScan,
  SearchSttList,
  SearchSttScan
} from "@/domain/entities/ListCariSTT";
import { CariSTTEndpoint } from "../../endpoints/CariSTTEndpoint";
import ApiService from "../../services/ApiService";
import downloadFile from "@/app/infrastructures/misc/common-library/DownloadFile";
import { Endpoints } from "../../misc/Endpoints";
import { SearchSttJsonRequestInteface } from "@/data/payload/contracts/CariSttRequest";
import {
  SearchSttFilter,
  SearchSttScanApiRequest
} from "@/data/payload/api/CariSttApiRequest";
import { AccountController } from '@/app/ui/controllers/AccountController';

export class CariSTTApiRepository implements CariSTTRepositoryInterface {
  private service: ApiService;
  private cariSTTMapper: CariSTTMapper;
  private endpoints: CariSTTEndpoint;

  constructor(
    service: ApiService,
    cariSTTMapper: CariSTTMapper,
    endpoints: CariSTTEndpoint
  ) {
    this.service = service;
    this.cariSTTMapper = cariSTTMapper;
    this.endpoints = endpoints;
  }

  public async getListCariSTT(
    params: CariSttRequest
  ): Promise<CariSttEntities> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getCariSTTList(params),
      {}
    );
    return this.cariSTTMapper.convertListCariSTTFromApi(resp);
  }

  public async getDetailSttScan(id: number): Promise<DetailSttScan> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getDetailSttScan(id),
      {}
    );
    return this.cariSTTMapper.convertSttPiecesSttDetailFromApi(resp);
  }

  public async getDownloadCariSTTList(id: number): Promise<any> {
    const title =
      AccountController.accountData.countryCode.toLowerCase() === "id"
        ? "CARI-STT"
        : "FIND-STT";
    return downloadFile(
      `${Endpoints.baseUrl}/${this.endpoints.getDownloadCariSTTList(id)}`,
      `${title}-${id}`,
      ".csv",
      true
    );
  }

  public async searchSttScan(
    payload: SearchSttJsonRequestInteface
  ): Promise<SearchSttScan> {
    const resp = await this.service.invoke(
      "post",
      this.endpoints.searchSttScan(),
      undefined,
      payload as SearchSttScanApiRequest
    );
    return this.cariSTTMapper.convertSearchSttScanDataFromApi(resp);
  }

  public async searchSttManifest(): Promise<DetailSttScan> {
    const resp = await this.service.invoke(
      "post",
      this.endpoints.searchStt(),
      undefined,
      undefined
    );
    return this.cariSTTMapper.convertSearchSttManifestDataFromApi(resp);
  }

  public async getSearchSttScanList(
    params: SearchSttFilter
  ): Promise<SearchSttList> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getSearchSttScanList(params),
      {}
    );
    return this.cariSTTMapper.convertGetSearchSttScanListDataFromApi(resp);
  }
}
